module.exports = __webpack_public_path__ + "static/media/yunhaochefushourufenpeixize.287c3c0d.png";